import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
// v0.6.64 — 销售业绩榜 agent 头像改 Flarum Avatar (辉哥 9/30 23:03 拍板: 全部用户头像改 Flarum Avatar)
//   Flarum Avatar 默认不渲染 <a> (点击不跳用户页), 默认无 border (无 box-shadow/outline)
import Avatar from 'flarum/common/components/Avatar';
import Api from '../utils/Api';
// v0.6.59 — 日期选择器公用 helper (v0.17.19 月份选择器复用 SalesTab 同款)
import { mountDatePicker } from '../utils/DatePickerHelper';
export default class StatsTab extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.kpis = [];
    this.ranking = [];
    this.coachDuration = [];
    // v0.17.19 — 「本周/本月/本季」三按钮 → 年月选择器 (辉哥 10/13 拍板)
    //   起因: 生产 3 条 completed 课次全在 2026-09, 而三个档位**一个都够不着** ——
    //   不是没数据, 是时间窗把数据全滤掉了。默认仍是当前月。
    this.selectedMonth = this.defaultMonth();
    this.rankTab = 'sales';
    this.loading = true;
    // v0.5.5 — StatsTab 接 activeSchoolId (辉哥 9/25 08:04 SOP, 跟 v0.5.3 CardTemplatesTab 同款)
    this.activeSchoolId = vnode.attrs.activeSchoolId;
    // v0.7.8b — 移动/桌面 JSX 不同 (mobile 3 列 + 角色 inline pill / desktop 6 列 + 独立角色列)
    //   辉哥 10/3 20:30 拍板, 用 isMobile 状态 + resize listener (跟 zpc-mover 中调 LESS 媒体查询 SOP 一致)
    this.isMobile = window.innerWidth < 768;
    this._onResize = this._onResize.bind(this);
    window.addEventListener('resize', this._onResize);
    // v0.17.19 (v0.17.21 改按课程类型) — 消课时长「按类型明细」的展开状态 (默认收起), 按 coach_id 记
    this.expandedCoach = new Set();
    // v0.17.19 — 月份选择器 flatpickr 实例 (跟 SalesTab 同款生命周期)
    this._monthPickerFp = null;
    this._monthPickerRetry = 0;
    this._monthPickerTimer = null;
    this.load();
  }

  // v0.5.5 — 父组件异步换校区时, 同步 attrs + 重新 load (跟 CardTemplatesTab.onbeforeupdate 同款)
  onbeforeupdate(vnode) {
    super.onbeforeupdate(vnode);
    if (vnode.attrs.activeSchoolId !== this.activeSchoolId) {
      this.activeSchoolId = vnode.attrs.activeSchoolId;
      this.load();
    }
  }

  // v0.17.19 — 月份选择器初始化时机 (完全照抄 SalesTab.js:oncreate/onupdate 同一套, 避免两处各写一遍)
  //   oncreate: DOM 就绪后 setTimeout 0 再试 (flatpickr 全局 + input 都要 ready)
  //   onupdate: view() 加载态返回 "加载中..." 时 input 还不存在, 有数据后补一次
  oncreate(vnode) {
    super.oncreate(vnode);
    setTimeout(() => this.initMonthPicker(), 0);
  }
  onupdate(vnode) {
    super.onupdate(vnode);
    this.initMonthPicker();
  }

  // v0.7.8b — 视口宽度变化时切换 mobile/desktop JSX 结构
  onremove(vnode) {
    super.onremove(vnode);
    window.removeEventListener('resize', this._onResize);
    // v0.17.19 — 切 tab 时销毁 flatpickr (它的日历 popover 挂在 document.body 上,
    //   不 destroy 会每次切 tab 泄漏一个实例 + 一个孤儿 DOM, 跟 SalesTab 同款处理)
    if (this._monthPickerTimer) {
      clearTimeout(this._monthPickerTimer);
      this._monthPickerTimer = null;
    }
    if (this._monthPickerFp) {
      this._monthPickerFp.destroy();
      this._monthPickerFp = null;
    }
  }
  _onResize() {
    const next = window.innerWidth < 768;
    if (next !== this.isMobile) {
      this.isMobile = next;
      m.redraw();
    }
  }

  // v0.17.19 — 默认月份 = 当前年月 (YYYY-MM), 跟 SalesTab.defaultMonth 同款
  defaultMonth() {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
  }
  async load() {
    try {
      this.loading = true;
      // v0.7.7 — A 方案: activeSchoolId 兜底 (辉哥 10/3 02:20 拍板)
      //   原: params 只在 activeSchoolId 有值时带 school_id, 否则裸 range → 后端返回全局空数据
      //   改: 如果 activeSchoolId 是 null, 试图从 app.store 的 schools 拿第一个; 仍拿不到则不发 school_id
      //   跟 SchedulerIndexPage L143-145 默认 school 兜底策略一致
      let effectiveSchoolId = this.activeSchoolId;
      if (!effectiveSchoolId) {
        try {
          const schools = app.store.all('schools');
          if (schools && schools.length > 0) effectiveSchoolId = String(schools[0].id());
        } catch (e) {/* store 还没初始化, 走原路 */}
      }
      // v0.17.19 — range → month (整 tab 共用一个月份: KPI / 经办人排行 / 消课时长全跟着走)
      const params = effectiveSchoolId ? {
        month: this.selectedMonth,
        school_id: effectiveSchoolId
      } : {
        month: this.selectedMonth
      };
      const r = await Api.get('stats', params);
      this.kpis = r.kpis || [];
      this.ranking = r.ranking || [];
      this.coachDuration = r.coach_duration || [];

      // v0.19.08 补正 — 把「经办人」(agent_id) 与「消课时长教练」(coach_id) 涉及的用户
      //   **预先灌进 app.store** (手法与理由见 preloadUsers() 的注释)
      this.preloadUsers();
    } catch (e) {
      console.error('load stats failed', e);
    } finally {
      this.loading = false;
      m.redraw();
    }
  }

  // v0.19.08 补正 — 把两栏头像涉及的用户**预先灌进 app.store** ⇒ 两栏都用上 Flarum 原生 <Avatar>
  //
  // ## 为什么必须自己灌 (根因)
  //   后端 stats 端点返回的是**顶层裸对象** ({kpis, ranking, coach_duration, month, month_valid}),
  //   **不是 JSON:API 信封、没有 `included`** ⇒ Flarum 的 `app.request` **不会**把这些用户
  //   push 进 store ⇒ `app.store.getById('users', coach_id)` 返回 undefined
  //   ⇒ `coachDurationRow()` 退回 `.ZS-avatar` 字母圈 (40px 蓝底),
  //      而「经办人」那栏的 agent 恰好是**当前登录用户** (Flarum 一定把他放进 store) ⇒ 原生 `.Avatar` (24px)
  //   ⇒ **两栏头像长得不一样** (这正是上一轮漏掉的那点)。
  //   ⛔ 后端一个字节都不改 (brief 红线) ⇒ 只能前端自己灌。
  //
  // ## 手法 (照抄本仓 RefundMgmtTab.preloadStudents() —— 坑都踩过了)
  //   · Flarum 2.0 的 `Store` **不会触发 `m.redraw()`** ⇒ find 回来后必须**主动 redraw 一次**
  //   · 失败必须**静默** (`.catch(() => null)`) —— 用户被隐藏 / 不可见时拿不到, 不能炸掉整个 tab
  //   · **已经在 store 里的** (`getById` 命中) 直接跳过 ⇒ 不必再发一次网络请求
  //     (当前登录用户就在 store 里 ⇒ 「经办人」那栏本来就不需要再拉)
  //   · id **去重** ⇒ 同一个人既是 agent 又是教练时只拉一次
  //
  // ## 调用点
  //   `load()` 里 —— stats 数据到位、**赋给 this.ranking / this.coachDuration 之后**调用
  //   (见上面 L111-113)。
  preloadUsers() {
    const ids = [];
    const push = id => {
      if (!id) return; // 跳过空值
      if (ids.indexOf(id) !== -1) return; // 去重
      if (app.store.getById('users', id)) return; // 已经在 store 里 ⇒ 跳过 (不必再 find)
      ids.push(id);
    };
    (this.ranking || []).forEach(row => push(row.agent_id));
    (this.coachDuration || []).forEach(row => push(row.coach_id));
    if (!ids.length) return;
    let pending = ids.length;
    const done = () => {
      pending -= 1;
      if (pending <= 0) m.redraw(); // 全部拉完 ⇒ **只 redraw 一次**
    };
    ids.forEach(id => {
      try {
        const p = app.store.find('users', id);
        if (p && typeof p.then === 'function') {
          p.then(done, done); // 成功 / 失败都算「这一条结束了」
        } else {
          done();
        }
      } catch (e) {
        done(); // ⛔ 静默失败 (用户不可见等)
      }
    });
  }

  // v0.17.19 — 月份选择器 (跟 SalesTab.js initMonthPicker/retryMonthPicker 同款, 逻辑不重写第二遍)
  //   monthSelect plugin 出 12 月网格 + 年份输入, 不受「最近 8 个月」限制
  async initMonthPicker() {
    if (this._monthPickerFp) return; // 已初始化, 幂等
    const textInput = this.element && this.element.querySelector('.ZS-month-picker-input');
    if (!textInput) {
      this.retryMonthPicker(); // view() 加载态还没渲染 input
      return;
    }
    this._monthPickerFp = await mountDatePicker(textInput, {
      mode: 'month',
      defaultDate: this.selectedMonth + '-01',
      // '2026-10' + '-01' = '2026-10-01', monthSelect 接受 ISO 日期
      onChange: (selectedDates, dateStr) => {
        if (selectedDates.length > 0 || dateStr) {
          // dateStr 是 'YYYY-MM' (dateFormat: 'Y-m' 触发), 直接喂 stats month param
          this.selectedMonth = dateStr;
          // v0.17.19 — 换月份时收起所有明细, 否则展开态会挂在已不存在的 coach 上
          this.expandedCoach.clear();
          this.load();
        }
      }
    });

    // vendor 未就绪 (helper 内部 waitForVendor 超时), 走 retry 兜底
    if (!this._monthPickerFp) {
      this.retryMonthPicker();
    }
  }

  // vendor flatpickr / input DOM 未就绪时重试 (上限 5s, 跟 SalesTab 同款 polling)
  retryMonthPicker() {
    if (this._monthPickerTimer || this._monthPickerRetry >= 50) return;
    this._monthPickerTimer = setTimeout(() => {
      this._monthPickerTimer = null;
      this._monthPickerRetry++;
      this.initMonthPicker();
    }, 100);
  }
  setRankTab(t) {
    this.rankTab = t;
  }

  // v0.17.19 (v0.17.21 改按课程类型) — 展开/收起某个教练的类型明细 (默认收起)
  toggleCoachTypes(coachId) {
    if (this.expandedCoach.has(coachId)) {
      this.expandedCoach.delete(coachId);
    } else {
      this.expandedCoach.add(coachId);
    }
    m.redraw();
  }

  // v0.7.8b — 经办人行 (辉哥 10/3 20:30 拍板设计稿 zpc-stats-v078b-mockup.html)
  //   严格按设计稿:
  //     - mobile (this.isMobile): 3 列 (经办人+role-pill inline / 业绩总额+avg / 单数)
  //     - desktop: 6 列 (经办人 / 角色 / 业绩总额 / 单数 / 平均客单价 / 合作跟单)
  //   角色色: sales 橙 #ff9500, coach 绿 #34c759 (跟现有 .ZS-role-tag 同色)
  rankingRow(r, i) {
    const userModel = r.agent_id ? app.store.getById('users', r.agent_id) : null;
    const fallbackLetter = (r.agent_name || '?').charAt(0);
    const avatarNode = userModel ? m(Avatar, {
      user: userModel
    }) : m("span", {
      className: "ZS-avatar"
    }, fallbackLetter);
    if (this.isMobile) {
      return m("div", {
        className: "ZS-ranking-grid new",
        key: r.agent_id
      }, m("div", {
        className: "ZS-agent"
      }, avatarNode, m("div", {
        className: "ZS-agent-name"
      }, m("span", {
        className: "name-text"
      }, r.agent_name), m("span", {
        className: 'role-pill ' + r.role
      }, r.role_label))), m("div", {
        className: "amount-cell"
      }, m("div", {
        className: "ZS-amount-blue"
      }, "\xA5 ", r.total_amount.toLocaleString()), m("div", {
        className: "avg"
      }, "\u5747 \xA5", r.avg_amount.toLocaleString())), m("div", {
        className: "count-cell"
      }, r.count, " \u5355"));
    }
    // desktop — 6 列 (砍"排名"列, 经办人/角色/业绩/单数/平均/合作)
    return m("div", {
      className: "ZS-ranking-grid new",
      key: r.agent_id
    }, m("div", {
      className: "ZS-agent"
    }, avatarNode, m("div", {
      className: "ZS-agent-name"
    }, m("span", {
      className: "name-text"
    }, r.agent_name))), m("div", null, m("span", {
      className: 'ZS-role-tag ' + r.role
    }, r.role_label)), m("div", {
      className: "ZS-amount-blue"
    }, "\xA5 ", r.total_amount.toLocaleString()), m("div", null, r.count, " \u5355"), m("div", null, "\xA5 ", r.avg_amount.toLocaleString()), m("div", {
      style: "color:var(--zs-text-2-9ca3af, #9ca3af);"
    }, r.co_listed));
  }

  // v0.17.19 — 月份选择器 (复用 SalesTab.renderMonthPicker 同款 DOM + 现有 LESS, 不新写样式)
  renderMonthPicker() {
    return m("div", {
      className: "ZS-month-picker"
    }, m("div", {
      className: "ZS-month-picker-row"
    }, m("span", {
      className: "ZS-month-picker-label"
    }, m("i", {
      className: "fas fa-calendar-days",
      style: "color:var(--zs-warning-f59e0b, #f59e0b);margin-right:6px;"
    }), "\u6570\u636E\u6708\u4EFD"), m("input", {
      className: "ZS-date-input-text ZS-month-picker-input",
      type: "text",
      value: this.selectedMonth
    })));
  }

  // v0.17.21 — 消课时长: 按**课程类型**的明细块 (点行展开, 默认收起)
  //   明细块自带一行「合计」, 值跟主行的「总课时 / 总确收金额」是同一个数 ——
  //   用户在这里把各类型加起来, 必须精确等于合计 (辉哥明确要求, 后端也是这么加的)。
  coachTypeDetail(c) {
    const types = c.types || [];
    return (
      // ⚠️ 这里**不能**加 key: 它和上面的 .ZS-dur-row 是同一个父 div 的两个子节点,
      //   而 .ZS-dur-row 没加 key —— mithril 报 "In fragments, vnodes must either all
      //   have keys or none have keys" 并让整个 redraw 抛异常, 展开功能直接不生效。
      //   key 由外层 coachDurationRow 的 <div key={c.coach_id}> 承担就够了。
      m("div", {
        className: "ZS-dur-detail"
      }, m("div", {
        className: "ZS-dur-detail-head"
      }, m("span", null, "\u8BFE\u7A0B\u7C7B\u578B"), m("span", {
        className: "ZS-dur-v"
      }, "\u6D88\u8BFE\u6570"), m("span", {
        className: "ZS-dur-v"
      }, "\u786E\u6536\u91D1\u989D")), types.map(t => m("div", {
        className: "ZS-dur-detail-row",
        key: String(t.type_id)
      }, m("span", {
        className: "ZS-dur-cat"
      }, t.type_name, t.no_card_lessons > 0 && m("em", {
        className: "ZS-dur-nocard",
        title: "\u8FD9\u4E9B\u8BFE\u6B21\u6CA1\u6709\u5173\u8054\u5B66\u5458\u5361, \u65E0\u8BFE\u5355\u4EF7\u53EF\u786E\u8BA4, \u786E\u6536\u91D1\u989D\u6309 0 \u8BA1"
      }, "\u65E0\u5361 ", t.no_card_lessons, " \u8BFE\u65F6")), m("span", {
        className: "ZS-dur-v"
      }, t.lessons), m("span", {
        className: "ZS-dur-v ZS-dur-amt"
      }, "\xA5 ", t.amount.toLocaleString()))), m("div", {
        className: "ZS-dur-detail-row ZS-dur-detail-total"
      }, m("span", null, "\u5408\u8BA1"), m("span", {
        className: "ZS-dur-v"
      }, c.total_lessons), m("span", {
        className: "ZS-dur-v ZS-dur-amt"
      }, "\xA5 ", c.total_amount.toLocaleString())), c.no_card_lessons > 0 && m("div", {
        className: "ZS-dur-detail-note"
      }, m("i", {
        className: "fas fa-circle-info",
        style: "margin-right:5px;"
      }), "\u672C\u6708\u5171 ", c.no_card_lessons, " \u8BFE\u65F6\u672A\u5173\u8054\u5B66\u5458\u5361, \u65E0\u8BFE\u5355\u4EF7\u53EF\u786E\u8BA4, \u786E\u6536\u91D1\u989D\u6309 0 \u8BA1 (\u8BFE\u65F6\u6570\u7167\u5E38\u8BA1\u5165)\u3002"))
    );
  }

  // v0.17.19 — 消课时长行
  //   ⚠️ 列用**语义 class** (.ZS-dur-c-coach / -time / -lessons / -amount / -toggle),
  //     绝不用 nth-child。原 7 列表是 `.ZS-ranking-grid:not(.new)`, 移动端靠 nth-child(3/6/7)
  //     定位要藏的列 —— 加列后位置一变就会藏错列 (该藏「角色」结果藏掉「总确收金额」),
  //     而且桌面端完全看不出来。所以消课时长整套换独立 grid class + 独立 LESS, 与经办人 tab 互不影响。
  //   v0.19.08 — 去掉「排名」列 ⇒ 列 class 少一个 .ZS-dur-c-rank (表头 + 行 + LESS 列宽三处同步)。
  //     ⛔ **排序没动**: 后端仍按 total_minutes desc 排 (usort), 行的先后顺序保持原样;
  //        「去掉排名」只是不再把序号显示出来, 不是取消排序。
  coachDurationRow(c) {
    const expanded = this.expandedCoach.has(c.coach_id);
    const types = c.types || [];
    // v0.19.08 — 教练头像 (照搬同文件 rankingRow() 的现成写法, 一个字都没改风格)
    //   coach_id 就是 Flarum users.id (后端 src/Model/Lesson.php 的 coach() → belongsTo(User)),
    //   ⇒ app.store.getById('users', c.coach_id) 能直接拿到 user model ⇒ <Avatar> 生效。
    //   取不到 user model 时 fallback 成首字母圈 (.ZS-avatar), 与「经办人」tab 行为完全一致。
    const userModel = c.coach_id ? app.store.getById('users', c.coach_id) : null;
    const fallbackLetter = (c.coach_name || '?').charAt(0);
    const avatarNode = userModel ? m(Avatar, {
      user: userModel
    }) : m("span", {
      className: "ZS-avatar"
    }, fallbackLetter);
    return m("div", {
      key: c.coach_id
    }, m("div", {
      className: 'ZS-dur-grid ZS-dur-row' + (expanded ? ' expanded' : ''),
      onclick: () => this.toggleCoachTypes(c.coach_id)
    }, m("div", {
      className: "ZS-dur-c-coach"
    }, avatarNode, m("div", {
      className: "ZS-dur-coach-text"
    }, m("span", {
      className: "ZS-dur-name"
    }, c.coach_name), m("span", {
      className: "ZS-dur-sub"
    }, c.total_minutes, " \u5206\u949F \xB7 ", c.total_lessons, " \u8BFE\u65F6"))), m("div", {
      className: "ZS-dur-c-time"
    }, c.total_minutes, " \u5206\u949F"), m("div", {
      className: "ZS-dur-c-lessons"
    }, c.total_lessons), m("div", {
      className: "ZS-dur-c-amount"
    }, "\xA5 ", c.total_amount.toLocaleString()), m("div", {
      className: "ZS-dur-c-toggle"
    }, m("i", {
      className: 'fas fa-chevron-' + (expanded ? 'up' : 'down'),
      style: "color:var(--zs-text-2-9ca3af, #9ca3af);font-size:11px;"
    }))), expanded && types.length > 0 && this.coachTypeDetail(c));
  }
  view() {
    return m("div", null, m("div", {
      className: "ZS-stats-head"
    }, m("div", {
      className: "ZS-stats-month"
    }, this.renderMonthPicker()), !this.loading && m("div", {
      className: "ZS-stats-grid"
    }, this.kpis.map((kpi, i) => m("div", {
      className: 'ZS-stat-card ' + (kpi.highlight ? 'ZS-stat-card-highlight' : ''),
      key: i
    }, m("div", {
      className: "ZS-stat-icon"
    }, m("i", {
      className: 'fas ' + kpi.icon,
      style: 'color:' + kpi.iconColor + ';'
    })), m("div", {
      className: "ZS-stat-text"
    }, m("div", {
      className: "ZS-stat-label"
    }, kpi.label), m("div", {
      className: "ZS-stat-value"
    }, kpi.value, kpi.unit && m("span", {
      style: "font-size:13px;color:var(--zs-text-2-9ca3af, #9ca3af);font-weight:normal;"
    }, " ", kpi.unit)), kpi.change && m("div", {
      style: 'font-size:12px;color:' + (kpi.up ? '#34c759' : 'var(--zs-danger-ff3b30, #ff3b30)') + ';margin-top:2px;'
    }, kpi.up ? '↑' : '↓', " ", kpi.change)))))), this.loading ? m("div", {
      style: "padding:60px;text-align:center;color:var(--zs-text-2-9ca3af, #9ca3af);"
    }, "\u52A0\u8F7D\u4E2D...") : m("div", {
      className: "ZS-ranking-table"
    }, m("div", {
      className: "ZS-ranking-header"
    }, m("div", {
      className: "ZS-ranking-tabs"
    }, m("div", {
      className: 'ZS-ranking-tab new-role ' + (this.rankTab === 'sales' ? 'active' : ''),
      onclick: () => this.setRankTab('sales')
    }, m("i", {
      className: "fas fa-user-tie",
      style: "color:var(--zs-purple-8b5cf6, #8b5cf6);margin-right:4px;"
    }), "\u7ECF\u529E\u4EBA"), m("div", {
      className: 'ZS-ranking-tab ' + (this.rankTab === 'duration' ? 'active' : ''),
      onclick: () => this.setRankTab('duration')
    }, m("i", {
      className: "fas fa-stopwatch",
      style: "color:var(--zs-warning-f59e0b, #f59e0b);margin-right:4px;"
    }), "\u6D88\u8BFE\u65F6\u957F")), m("button", {
      className: "ZS-btn secondary"
    }, "\u5BFC\u51FA Excel")), this.rankTab === 'duration' ? m('[', null, m("div", {
      className: "ZS-dur-grid ZS-dur-head"
    }, m("div", {
      className: "ZS-dur-c-coach"
    }, "\u6559\u7EC3"), m("div", {
      className: "ZS-dur-c-time"
    }, "\u6D88\u8BFE\u65F6\u957F"), m("div", {
      className: "ZS-dur-c-lessons"
    }, "\u603B\u8BFE\u65F6"), m("div", {
      className: "ZS-dur-c-amount"
    }, "\u603B\u786E\u6536\u91D1\u989D"), m("div", {
      className: "ZS-dur-c-toggle"
    })), this.coachDuration.map(c => this.coachDurationRow(c))) : this.isMobile ? m('[', null, m("div", {
      className: "ZS-ranking-grid new header-row"
    }, m("div", null, "\u7ECF\u529E\u4EBA"), m("div", null, "\u4E1A\u7EE9\u603B\u989D"), m("div", {
      style: "text-align:right;"
    }, "\u5355\u6570")), this.ranking.map((r, i) => this.rankingRow(r, i))) : m('[', null, m("div", {
      className: "ZS-ranking-grid new header-row"
    }, m("div", null, "\u7ECF\u529E\u4EBA"), m("div", null, "\u89D2\u8272"), m("div", null, "\u4E1A\u7EE9\u603B\u989D"), m("div", null, "\u5355\u6570"), m("div", null, "\u5E73\u5747\u5BA2\u5355\u4EF7"), m("div", null, "\u5408\u4F5C\u8DDF\u5355")), this.ranking.map((r, i) => this.rankingRow(r, i))), this.rankTab === 'duration' && this.coachDuration.length === 0 && m("div", {
      style: "padding:40px;text-align:center;color:var(--zs-text-2-9ca3af, #9ca3af);"
    }, "\u6682\u65E0\u6570\u636E"), this.rankTab !== 'duration' && this.ranking.length === 0 && m("div", {
      style: "padding:40px;text-align:center;color:var(--zs-text-2-9ca3af, #9ca3af);"
    }, "\u6682\u65E0\u6570\u636E")));
  }
}
flarum.reg.add('ziiven-ziven-scheduler', 'forum/components/StatsTab', StatsTab);